import { Translation } from '@ps/web-shared-components';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import HandIcon from '@swf/core/assets/icons/hand-icon.svg';
import { StatusCode } from '@swf/core/enums/statusCode';
import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';

import { TXTWCL_24_hour_lockout } from './PanicButtonVegas.messages.json';
import styles from './PanicButtonVegas.scss';

const SELF_EXCLUSION_ERROR_STATUS_CODES = [
  StatusCode.OBSOLETE_ERROR,
  StatusCode.ALREADY_BANNED,
  StatusCode.ALREADY_SELF_EXCLUDED_ERROR
];

const PanicButtonVegas: React.FC = () => {
  const request = useRequest();
  const submittingRef = useRef(false);

  const { modal } = useDispatch<Dispatch>();

  const excludeFor24Hours = () => {
    if (submittingRef.current) return;

    submittingRef.current = true;
    request({
      service: 'responsiblegaming.panicbutton'
    }).subscribe(
      ({ body: { statusCode } }) => {
        submittingRef.current = false;
        modal.enqueue({ path: '/notifications/cooling-off-period', locationState: { statusCode } });
      },
      ({ headers: { statusCode } }) => {
        submittingRef.current = false;
        if (SELF_EXCLUSION_ERROR_STATUS_CODES.includes(statusCode)) {
          modal.enqueue({
            path: '/notifications/exclusion-info-vegas',
            locationState: { statusCode }
          });
        }
      }
    );
  };

  return (
    <div className={styles.panicButton} onClick={excludeFor24Hours}>
      <HandIcon width={18} height={18} />
      <Translation {...TXTWCL_24_hour_lockout} />
    </div>
  );
};

export default PanicButtonVegas;
